import { inject, provide } from 'vue'
import { DateLocale } from '@/support/DateHelper'

const DATE_HELPER_KEY = Symbol('dateHelper')

/**
 * Provide a reactive DateHelper instance to child components.
 *
 * @param {Ref<DateHelper>} dateHelperRef
 */
export function provideDateHelper(dateHelperRef) {
    provide(DATE_HELPER_KEY, dateHelperRef)
}

/**
 * Inject the DateHelper instance provided by a parent component.
 *
 * @returns {Ref<DateHelper>}
 */
export function useDateHelper() {
    const helper = inject(DATE_HELPER_KEY)

    if (!helper) {
        throw new Error(
            'DateHelper not provided — ensure provideDateHelper() is called in a parent component.',
        )
    }

    return helper
}

export {
    DateLocale,
}

